<script setup lang="ts">
  import { StatusBadge } from "@/components/episto-ui/status-badge";
  import { SURVEY_STATUS_VARIANTS } from "./surveyStatus";

  defineProps<{ status: string }>();
</script>

<template>
  <StatusBadge
    :status="status"
    :variants="SURVEY_STATUS_VARIANTS"
    :dot="status === 'live'"
    dot-class="bg-episto-teal" />
</template>
